import { useEffect, useState } from "react";
import Development from "./Development";
import { useDispatch, useSelector } from 'react-redux';
import RequisitionAction from '../../../../../../../Store/Component/Requisition/RequisitionAction'


const DevelopmentContainer = (props?: any) => {
  const managedEquipRef = props?.managedEquipRef;

//dispatch
const dispatch = useDispatch();
const [manufacturerDropdownList, setManufacturerDropdownList] = useState<any>([])
const [categoryDropdownList, setCategoryDropdownList] = useState<any>([])

  const {managedEquipmentDropDown, managedEquipmentValues, editRequestDetails, isEditRequestClick, selectedEquipmentType }: any = useSelector((state? : any) => ({
    managedEquipmentDropDown: state.ManagedEquipmentDropDownReducer.managedEquipmentDropDown,
    managedEquipmentValues: state.RequisitionReducer.managedEquipmentValues,
    editRequestDetails: state.RequisitionReducer.editRequestDetails,
    isEditRequestClick: state.RequisitionReducer.isEditRequestClick,
    selectedEquipmentType: state.RequisitionReducer.selectedEquipmentType,
  }));

  ///Modified dropDown values as required
  useEffect(()=>{
    if (managedEquipmentDropDown?.length > 0) {
      managedEquipmentDropDown?.map((item: any) => {
        if (item?.dropdownName == "Manufacturer") {
          const defaultManufacturerOption = {
            text: "Select Manufacturer",
            value: null
        };
        item?.dropdownList?.unshift(defaultManufacturerOption);
          let manufacturerDropdownListTemp = item?.dropdownList?.map((val: any) =>
            ({ text: val.text, value: val.value, label: val.text, key: val.value })
          );
          setManufacturerDropdownList(manufacturerDropdownListTemp)
        } else if (item?.dropdownName == "Category") {
          const defaultCategoryOption = {
            text: "Select Category",
            value: null
        };
        item?.dropdownList?.unshift(defaultCategoryOption);
        let categoryDropdownListTemp = item?.dropdownList?.map((val: any) =>
            ({ text: val.text, value: val.value, label: val.text, key: val.value })
          );
          setCategoryDropdownList(categoryDropdownListTemp)
        }
      })
    }
  },[selectedEquipmentType, managedEquipmentDropDown])


  useEffect(() => {
    if (isEditRequestClick) {
      let managedEquipmentValuesTemp: any = {}
      let selectedManufacturer: any = ""
      let selectedCategory: any = ""
      if (editRequestDetails?.manufacturer && manufacturerDropdownList?.length > 0) {
        selectedManufacturer = manufacturerDropdownList?.find((manufacturer: any) => manufacturer?.value === editRequestDetails?.manufacturer)
      }

      if (editRequestDetails?.category && categoryDropdownList?.length > 0) {
        selectedCategory = categoryDropdownList?.find((category: any) => category?.value === editRequestDetails?.category)
      }
      managedEquipmentValuesTemp = { ...managedEquipmentValues, manufacturer: selectedManufacturer, category: selectedCategory }
      dispatch(RequisitionAction.setManagedEquipmentValues(managedEquipmentValuesTemp))
    }
  }, [isEditRequestClick, manufacturerDropdownList, categoryDropdownList])


 
const handleCategoryChange = (e:any,item:any,name:string) => {
  dispatch(RequisitionAction.setManagedEquipmentValues({
      ...managedEquipmentValues,
      [name]: item
  }));

  if(item?.label !==  'Select Category') {
    managedEquipRef.current[2]?.focus()
  }
}
const handleManufacturerChange = (e:any,item:any,name:string) => {
  dispatch(RequisitionAction.setManagedEquipmentValues({
    ...managedEquipmentValues,
    [name]: item
}));
  if(item?.label !==  'Select Manufacturer') {
    managedEquipRef.current[8]?.focus()
  }
}




  useEffect(()=> {
    managedEquipRef.current[1]?.focus()
  },[])
    return (
      <Development
        managedEquipmentValues={managedEquipmentValues}
        categoryDropdownList={categoryDropdownList}
        manufacturerDropdownList={manufacturerDropdownList}
        managedEquipRef={managedEquipRef}
        handleCategoryChange={handleCategoryChange}
        handleManufacturerChange={handleManufacturerChange}
      />
    )
  }
  
  export default DevelopmentContainer;